import styles from "./Footer.module.scss";
import tgIcon from "../../assets/pictures/icons/telegram-icon-white.svg";
import vkIcon from "../../assets/pictures/icons/vk-icon.svg";
import { LINKS } from "../../const";

const Footer: React.FC = () => {
	return (
		<div className={styles.footerContainer}>
			<div className={styles.footerLinks}>
				<a href="#" target="_blank" aria-label="vk"><img src={vkIcon} alt="vk"/></a>
				<a href={LINKS.telegram} target="_blank" aria-label="telegram"><img src={tgIcon} alt="telegram"/></a> 
			</div>
			<p className={styles.footerCopyright}>© Copyright 2025 - Visper </p>
		</div>
	);
};

export default Footer;
